class Facturacion {
    tpo_fac = null;
    comprobante = null;
    s_periodo = null;
    fec_ven = null;
    total_bas = null;
    s_tot_recargo = null;
    ajustado = null;
    estado = null;

    tipo_full = null;

    tipos = {
        "NC": "Nota de Credito",
        "FC": "Facturas",
        "FCPF": "Facturas Plan de Financiación",
        "PCR": "Pago Duplicado",
        "PCRM": "Plata a Cuenta"
    };
    
    isChecked = false;

    visible = null;

    seleccionable = null;

    constructor(obj) {
        // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];

        var date = new Date(this.fec_ven)
        var today = new Date();
        
        if (date > today){
            this.estado = 'Por Vencer';
        } else {
            this.estado = 'Vencida';
        }

        this.fec_ven = this.formatDateFactura(date);

        this.tipo_full = this.tipos[this.tpo_com.trim()];
    }

    formatDateFactura(date) {
        var d = new Date(date),
            month = '' + (d.getUTCMonth() + 1),
            day = '' + d.getUTCDate(),
            year = d.getUTCFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }
}

export default Facturacion